import { render } from "./login.vue?vue&type=template&id=f208aad0&scoped=true&ts=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=f208aad0&lang=scss&scoped=true"

import exportComponent from "E:\\workProject\\App.Live.Department.PC\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f208aad0"]])

export default __exports__